var $ = jQuery;

$('input[type="search"]').attr('placeholder', 'Enter Keyword');


//
// /***details page js ***/
//
// $('.slider-for').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false,
//     fade: true,
//     asNavFor: '.slider-nav',
//     // variableWidth: true,
//     adaptiveHeight: true,
//     rows: 0
// });
// $('.slider-nav').slick({
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     dots: false,
//     focusOnSelect: true,
//     infinite: true,
//     asNavFor: '.slider-for',
//     // variableWidth: true,
//     adaptiveHeight: true,
//     rows: 0,
//     nextArrow: '<i class="dt-arrow next fa fa-angle-right"></i>',
//     prevArrow: '<i class="dt-arrow prev fa fa-angle-left"></i>',
// });



/***details page js ***/




